import { Inject, Injectable } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';
import { HeapCustomEventType, HeapEventProperties } from '../domain/heap-event.types';
import { HeapWindow } from '../domain/heap-window.model';

@Injectable({
  providedIn: 'root',
})
export class HeapEventService {
  public constructor(@Inject(WA_WINDOW) private readonly window: HeapWindow) {}

  public trackCustomEvent(eventType: HeapCustomEventType, properties?: HeapEventProperties | null): void {
    const heap = this.window?.heap;

    if (!heap) {
      console.error('Heap not ready', heap);
      return;
    }

    heap.track(eventType, properties);
  }
}
